/* eslint-disable import/order */
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducers as authenticationReducer } from '@saucelabs/sl-container-authentication';
import { reducers as confirmAlertReducer } from '@saucelabs/sl-container-confirm-alert';
import { reducers as notificationsReducer } from '@saucelabs/sl-container-notifications';
import { reducers as modalReducer } from '@saucelabs/sl-container-modal';
import { reducers as errorPagesReducer } from '@saucelabs/sl-container-error-pages';
import { reducers as concurrencyReducer } from '@saucelabs/sl-module-concurrency';
import { reducers as userTunnelsReducer } from '@saucelabs/sl-module-tunnels';
import { reducers as userReducer } from '@saucelabs/sl-module-user';
import { reducers as usageReducer } from '@saucelabs/sl-module-usage';
import { reducers as performanceReducer } from '@saucelabs/sl-module-performance';
import { reducers as tableReducer } from '@saucelabs/sl-container-table';
import { reducers as cloudtypeReducer } from '@saucelabs/sl-module-cloudtype';
import { reducers as integrationsReducer } from '@saucelabs/sl-module-integrations';
import { reducers as onboardingReducer } from '@saucelabs/sl-module-onboarding';

import dashboardReducer from './dashboard/ducks/dashboard-container-new/reducers';
import applicationReducer from './application/reducers';
import { reducers as slInviteReducer } from '@saucelabs/sl-container-invite';

const apps = combineReducers({
  analytics: () => ({}),
  app: applicationReducer,
  appManagement: () => ({}),
  archives: () => ({}),
  auth: () => ({}),
  billingLegacy: () => ({}),
  billing: () => ({}),
  builds: () => ({}),
  extendedDebugging: () => ({}),
  gettingStarted: () => ({}),
  healthCheck: () => ({}),
  invitations: () => ({}),
  job: () => ({}),
  jobs: () => ({}),
  manual: () => ({}),
  performance: performanceReducer,
  teamManagement: () => ({}),
  tunnels: () => ({}),
  visual: () => ({}),
});

const createReducer = (history) => combineReducers({
  // react & redux 3rd party libs
  router: connectRouter(history),

  // cross package stuff
  confirmedAlerts: confirmAlertReducer,
  dashboard: dashboardReducer,
  modal: modalReducer,
  notifications: notificationsReducer,
  errorPage: errorPagesReducer,
  table: tableReducer,

  // FIXME: should be cleaned and moved into `me` key at the top level of store
  // currently logged user
  usage: usageReducer,
  user: authenticationReducer,
  userData: userReducer,
  userConcurrency: concurrencyReducer,
  userTunnels: userTunnelsReducer,
  cloudType: cloudtypeReducer,
  integrations: integrationsReducer,

  // packages specific store
  apps,
  onboarding: onboardingReducer,
  // for the global invite and the continuous onboarding
  invite: slInviteReducer,
});

export default createReducer;
